import * as React from 'react'
import _ from 'underscore'

interface Props {
    name: string
    label: string
    initialValue: string
    onChange: (value: string) => void
    removable: boolean
    onRemove: () => void
    maxWidth: string
}

interface State {
    currentValue: string
}

class TextInput extends React.Component<Props, State> {
    public static defaultProps = {
        removable: true,
        maxWidth: '400px',
    }

    private onChange

    constructor(props) {
        super(props)

        this.state = {
            currentValue: props.initialValue,
        }

        this.onChange = _.debounce(value => {
            this.props.onChange(value)
        }, 300)
    }

    public render() {
        const { onRemove, removable, name, label, maxWidth } = this.props
        const { currentValue } = this.state

        return (
            <div className="input-group form-group" style={{ maxWidth }}>
                <span className="input-group-addon">{label}</span>
                <input
                    type="text"
                    className="form-control"
                    name={name}
                    value={currentValue}
                    onChange={ev => {
                        const { value } = ev.target

                        this.setState({ currentValue: value })
                        this.onChange(value)
                    }}
                />
                {!removable ? null : (
                    <span className="input-group-btn">
                        <button className="btn btn-default" onClick={onRemove}>
                            <i className="fa fa-times-circle" />
                        </button>
                    </span>
                )}
            </div>
        )
    }
}

export default TextInput
